import React from 'react';
import DynamoDbTables from '../components/DynamoDbTables';

export default function Admin(props) {
  return <DynamoDbTables {...props} />;
}
